import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

const ratingFormatter = new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 2,
})

export type Pretty<T> = {
    [K in keyof T]: T[K]
}

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs))
}

export function fullAddress(
    address: { street: string; city: string; postalCode: string; country: string },
    separator = ', ',
) {
    return [
        [address.street].filter(Boolean).join(separator),
        [address.postalCode, address.city].filter(Boolean).join(separator),
        [address.country].filter(Boolean).join(separator),
    ]
        .filter(Boolean)
        .join(separator)
}

export function formatRating(rating: number | null | undefined, fallback = '-') {
    if (typeof rating !== 'number' || !Number.isFinite(rating)) {
        return fallback
    }

    return ratingFormatter.format(rating)
}
